import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'

import { ICReportTablePrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { income } from '@/react-query/queries/ic-report/hooks'

const colDefs = createColDefs([
  {
    field: 'new_duration',
    headerName: 'New Duration',
    valueFormatter: (params) => `${params?.value?.toFixed(2)}y`,
  },
  {
    field: 'old_duration',
    headerName: 'Old Duration',
    valueFormatter: (params) => `${params?.value?.toFixed(2)}y`,
  },
  {
    field: 'duration_change',
    headerName: 'Change',
    valueFormatter: (params) => `${params?.value?.toFixed(2)}y`,
  },
])

export interface IncomeDurationTableProps extends ICReportTablePrimitive {}

export const IncomeDurationTable: React.FC<IncomeDurationTableProps> = ({ params, options }) => {
  const query = income.useDuration(params)
  const data = query.data

  return (
    <CustomAgGrid
      rowData={data}
      columnDefs={colDefs}
      statusBar={{ statusPanels: [] }}
      {...options}
    />
  )
}
